export function setupFormTracking() {
    const formModules = document.querySelectorAll('.form-module');

    function submitAcForm(e) {
        const form = e.currentTarget;

        if (!form.hasAttribute('data-tracked') && form.reportValidity()) {
            e.preventDefault();

            const formModule = form.closest('.form-module');

            if (formModule) {
                const formNameElm = formModule.querySelector('.form__tracking-name');
                const formNameValue = formNameElm ? formNameElm.getAttribute('data-form-tracking-name') : '';
                const formEmailField = form.querySelector('input[type="email"]');
                const userEmailValue = formEmailField ? formEmailField.value : '';

                window.dataLayer = window.dataLayer || [];
                window.dataLayer.push({
                    'event': 'form_submission',
                    'formName': formNameValue,
                    'userEmail': userEmailValue
                });

                form.setAttribute('data-tracked', 'true');
                //form.submit();
            }
        }
    }

    formModules.forEach(formModule => {
        const form = formModule.querySelector('form');

        if (form) {
            form.addEventListener('submit', submitAcForm);
        }
    });
}
